import { styled } from '@mui/material/styles';

import { palette, Theme } from '../../theme';
import { Heading } from '../Heading';

export const StyledAppTile = styled('div')`
    max-width: 102.4rem;
    padding-bottom: 3rem;
    margin: auto;
    border: 0.2rem solid ${palette.common.lightGrey};
    border-radius: 0.8rem;
`;

export const StyledHeading = styled(Heading)`
    font-size: 2.3rem;
    line-height: 2.8rem;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('mobile')} {
        font-size: 2.6rem;
        line-height: 3rem;
        letter-spacing: -0.15rem;
    }
`;

export const StyledContainer = styled('div')`
    padding: 3rem 3rem 0 3rem;
    margin-bottom: 1rem;
    text-align: left;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('mobile')} {
        padding: 3rem 6rem 0 3rem;
        text-align: center;
    }
`;

export const SecondaryTitle = styled('div')`
    margin-top: 0.5rem;
`;

export const StyledImageContainer = styled('div')`
    display: flex;
    min-height: 15rem;
    max-height: 35.8rem;

    img {
        border-top-left-radius: 0.8rem;
        border-top-right-radius: 0.8rem;
    }
`;

export const StyledCheckList = styled('ul')`
    padding: 0;
    margin: 2rem 0 2rem;
    font-weight: normal;
    text-align: left;

    li {
        display: flex;
        margin-bottom: 1rem;
        list-style: none;

        svg {
            margin-top: 0.2rem;
            margin-right: 1.1rem;
        }
    }

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('mobile')} {
        display: inline-block;
        column-count: 2;
        column-gap: 4rem;
        margin: 3rem 0 2rem;
    }
`;

export const LinksContainer = styled('div')`
    display: flex;
    gap: 1rem;
    justify-content: center;
    padding-top: 1rem;

    a {
        display: contents;
    }

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('mobile')} {
        gap: 2rem;
        padding-top: 0;
    }
`;
